module.exports = __webpack_public_path__ + "img/part-5-title.a26df0ee.png";